var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.17 23.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.36,8.75C3.52-1.28,16.71-4,22.13,7.57c5.15,14.85-19,22.57-21.77,7.18A12.81,12.81,0,0,1,.36,8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.36,17.75c-.32,1.15-.76,2.58-1.86,3.06-.38.17-.81-.16-1.22-.24V2.92c.41-.07.85-.39,1.23-.22,1.08.49,1.53,1.9,1.85,3.05A22.63,22.63,0,0,1,40.36,17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.06,12.91C24.12-3.9,35.85-.63,35.2,11.33,35.61,23.85,25.16,26,24.06,12.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.44ac499ed12be48fd51769a84585a3ef.svg";
export { ForwardRef as ReactComponent };